import { render, staticRenderFns } from "./login-attempts-modal.vue?vue&type=template&id=165a2f1a&scoped=true&"
import script from "./login-attempts-modal.vue?vue&type=script&lang=js&"
export * from "./login-attempts-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a2f1a",
  null
  
)

export default component.exports